import React from 'react'
import QuestionContainer from './QuestionContainer'
import FileQuestion from '../../../../components/FileQuestion'
import Grid from '@material-ui/core/Grid'
import { change, formValueSelector } from 'redux-form'
import { useSelector } from 'react-redux'

export default ({
    question,
    position,
    positionDisplay,
    value,
    counter,
    displayCount,
    fieldValidators,
    meta: { touched, invalid, error, form, dispatch },
    disabled,
    isBilateral,
    isBilateralFullInfo,
    displayInstructionAsIcon,
    uniqueKey,
    ...rest
}) => {
	const isLabelContainerPreserved = !!isBilateral && !!isBilateralFullInfo
    const name = `answers.file._${question.uniqueId}._${uniqueKey}`

   const selector = formValueSelector(form)
	const currentValue = useSelector((state) => selector(state, name))

    const onRemoveAnswer = () => {
		dispatch(change(form, name, null))
		question.value = null
	}

    return (
        <QuestionContainer
            data-testid="question-container-file"
            title={`${question.title}`} titleRequered = {`${question.isOptional ? '' : ' *'}`}
            position={position}
            positionDisplay={positionDisplay}
            instructions={question.instructions}
            canRemoveAnswer={question.isOptional && currentValue}
			onRemoveAnswer={onRemoveAnswer}
            isBilateral={isBilateral}
            displayInstructionAsIcon={displayInstructionAsIcon}
            children={
                <Grid>
					<Grid
						container
					>
						{
							!!isLabelContainerPreserved
							&& <Grid xs={6} />
						}
						<Grid
							item
							xs={isLabelContainerPreserved ? 6 : 12}
						>
                            <FileQuestion
                                data-testid="question-container-file-field"
                                question={question}
                                position={position}
                                positionDisplay={positionDisplay}
                                validate={fieldValidators}
                                disabled={disabled}
                                inputName={name}
                            />
                         </Grid>
                    </Grid>
               </Grid>
            }
        />
    )
}